import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28a13926&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/addRounds.scss?vue&type=style&index=0&id=28a13926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a13926",
  null
  
)

export default component.exports